import { CheckinButtonModule, ProgressTrackerModule } from '@my-account/components';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HmfAlertBannerComponent, HmfButtonComponent, HmfModalComponent, HmfTextInputComponent } from '@dsg-tech/homefield-angular';
import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconAlertErrorFilled,
	homefieldIconAlertInfoFilled,
	homefieldIconBuildingStoreDsgAlt,
	homefieldIconDsgStorePickup,
	homefieldIconGgStorePickup,
	homefieldIconGggStorePickup,
	homefieldIconOrderDelivery,
	homefieldIconPlStorePickup,
	homefieldIconSignCheck,
	homefieldIconVehicleShipping
} from '@dsg-tech/homefield-angular-icons';

import { AdjustmentDialogComponent } from './adjustment-dialog/adjustment-dialog.component';
import { CommonModule } from '@angular/common';
import { ConfirmationEmailModalComponent } from './confirmation-email-modal/confirmation-email-modal.component';
import { DynamicTemplateLoader } from '@shared/utils/services';
import { HomefieldButtonModule } from '@homefield';
import { HtmlSanitizerPipe } from '@shared/utils/pipes';
import { ManualAdjustmentDialogComponent } from './manual-adjustment-dialog/manual-adjustment-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { NgModule } from '@angular/core';
import { OrderDetailCardsComponent } from './order-detail-cards.component';
import { PaymentSummaryModule } from '@shared/components';
import { TaxDialogComponent } from './tax-dialog/tax-dialog.component';

@NgModule({
	declarations: [
		AdjustmentDialogComponent,
		ConfirmationEmailModalComponent,
		ManualAdjustmentDialogComponent,
		OrderDetailCardsComponent,
		TaxDialogComponent
	],
	providers: [ DynamicTemplateLoader ],
	exports: [
		OrderDetailCardsComponent
	],
	imports: [
		CheckinButtonModule,
		CommonModule,
		FormsModule,
		HmfAlertBannerComponent,
		HmfButtonComponent,
		HmfModalComponent,
		HmfTextInputComponent,
		HomefieldButtonModule,
		HomefieldIconLibraryModule,
		HtmlSanitizerPipe,
		MatDialogModule,
		PaymentSummaryModule,
		ProgressTrackerModule,
		ReactiveFormsModule
	]
})
export class OrderCardsModule {
	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([homefieldIconAlertErrorFilled, homefieldIconAlertInfoFilled,
			homefieldIconVehicleShipping, homefieldIconBuildingStoreDsgAlt, homefieldIconDsgStorePickup,
			homefieldIconGgStorePickup, homefieldIconGggStorePickup, homefieldIconPlStorePickup,
			homefieldIconOrderDelivery, homefieldIconSignCheck]);
	}
}
